import Input from "app/components/Input";
import React from "react";
import { useSelector } from "react-redux";
import { selectSprintFormDta } from "../../redux/selector";
import { useDispatch } from "react-redux";
import { actions } from "../../redux/slice";
import TextArea from "app/components/TextArea";

const LeftArea = () => {
  const dispatch = useDispatch();
  const form = useSelector(selectSprintFormDta);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const key = name;
    dispatch(actions.updateFormValue({ key: key, value: value }));
  };

  return (
    <div className=" flex flex-col gap-4 w-full ">
      <Input
        id="name"
        value={form.name.name}
        error={form.name.error}
        onChange={handleChange}
        name="name.name"
        label="Sprint name*"
        placeholder="Enter sprint name"
      />
      <TextArea
        label="Sprint description"
        placeholder="Enter sprint description"
        id={"description"}
        value={form.description}
        name="description"
        onChange={(e) => {
          dispatch(
            actions.updateFormValue({
              key: "description",
              value: e.target.value,
            })
          );
        }}
        minRow={10}
        className="w-full rounded-l-none rounded-r-none border-t-0 h-auto "
        textAreaClassName="!items-start w-full !h-full resize-none focus:outline-none overflow-hidden"
        containerClassName="w-full"
      />
    </div>
  );
};

export default LeftArea;
